module.exports = __webpack_public_path__ + "b4b3a30948aaa59a3717c237708906c1.svg";